import React from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import avatar1 from "../../assets/images/users/avatar-1.jpg"
import profileImg from "../../assets/images/profile-img.png"
import {
  useCampusVirtualAuthenticatedUser,
  useCampusVirtualNombreCampusSeleccionado,
} from "../../store/campusvirtual/selectors"

const WelcomeComp = ({ cobrado, noRecibos, isLoading }) => {
  //
  const oAuthenticatedUser = useCampusVirtualAuthenticatedUser()
  const oCampusCurrent = useCampusVirtualNombreCampusSeleccionado()

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary-subtle">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Welcome Back !</h5>
                <p>{oCampusCurrent} Dashboard Financiero</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  src={oAuthenticatedUser.avatarUrl}
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <h5 className="font-size-15 text-truncate">
                {oAuthenticatedUser.Username}
              </h5>
              <p className="text-muted mb-0 text-truncate">{oCampusCurrent}</p>
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    {isLoading ? (
                      <React.Fragment>
                        <h5 className="card-title placeholder-glow">
                          <span className="placeholder col-12 placeholder-lg bg-primary"></span>
                        </h5>
                      </React.Fragment>
                    ) : (
                      <h5 className="font-size-15">{noRecibos}</h5>
                    )}

                    <p className="text-muted mb-0">Recibos</p>
                  </Col>
                  <Col xs="6">
                    {isLoading ? (
                      <React.Fragment>
                        <h5 className="card-title placeholder-glow">
                          <span className="placeholder col-12 placeholder-lg bg-primary"></span>
                        </h5>
                      </React.Fragment>
                    ) : (
                      <h5 className="font-size-15">
                        {cobrado.toLocaleString("es-MX", {
                          style: "currency",
                          currency: "MXN",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                      </h5>
                    )}
                    <p className="text-muted mb-0">Cobrado</p>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Link to="" className="btn btn-primary  btn-sm disabled">
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp
